import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.onboardingProcesses],
        config: {
            headerName: getLocalizedString("processCodeAlt"),
            field: 'code',
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.onboardingProcesses],
        config: {
            headerName: getLocalizedString("processNameAlt"),
            field: 'name',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.onboardingProcesses],
        config: {
            headerName: getLocalizedString("processStatusLong"),
            field: 'statusString',
            filter: "agSetColumnFilter",
            cellRenderer: "StatusRenderer",
        }
    },
    {
        pages: [paths.onboardingProcesses],
        config: {
            headerName: getLocalizedString("onboardingStartDateAlt"),
            field: 'startDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.onboardingProcesses],
        config: {
            headerName: getLocalizedString("onboardingEndDateAlt"),
            field: 'endDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.onboardingProcesses],
        config: {
            headerName: getLocalizedString("profile"),
            field: 'profileString',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.onboardingProcesses],
        config: {
            headerName: getLocalizedString("totalAssignedCollaborators"),
            field: 'onboardingAmount',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            cellClass: "currencyValueNoDecimal",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.onboardingProcesses],
        config: {
            headerName: getLocalizedString("collaboratorsWithPlannedStatus"),
            field: 'plannedAmount',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            cellClass: "currencyValueNoDecimal",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.onboardingProcesses],
        config: {
            headerName: getLocalizedString("collaboratorsWithInProgressStatus"),
            field: 'onCourseAmount',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            cellClass: "currencyValueNoDecimal",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.onboardingProcesses],
        config: {
            headerName: getLocalizedString("employeesWithCompletedOnboarding"),
            field: 'doneAmount',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            cellClass: "currencyValueNoDecimal",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.onboardingProcesses],
        config: {
            headerName: getLocalizedString("employeesWithPausedOnboarding"),
            field: 'stoppedAmount',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            cellClass: "currencyValueNoDecimal",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.onboardingProcesses],
        config: {
            headerName: getLocalizedString("comments"),
            field: 'comment',
            filter: "agTextColumnFilter",
        }
    },
]